import emojis from "@/components/markdown/view/data/emojis"
import { useQuery } from "@tanstack/react-query"
import React, { useEffect } from "react";

export default function SelectEmoji({
    textareaRef,
    searchTerm
}: any) {
    const allEmojis = useQuery({
        queryKey: ["emojis"],
        queryFn: async () => {
            const data = await fetch("__SITE_BASE__/api/me/reactions");
            const json = (await data.json() as any).reactions;
            const mergedEmojis = [...emojis, ...json];
            return mergedEmojis;
        },
        retry: 1,
        retryDelay: 1000,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
    })

    const [focusedEmoji, setFocusedEmoji] = React.useState(0);
    const [isSelectingEmoji, setIsSelectingEmoji] = React.useState(false);
    const tagEmoji = (emoji: any) => {
        if (textareaRef.current) {
            const textarea = textareaRef.current;
            const selectionStart = textarea.selectionStart;
            const lastColon = textarea.value.lastIndexOf(":", selectionStart - 1);
            const before = textarea.value.slice(0, lastColon);
            const after = textarea.value.slice(selectionStart);
            if(!emoji) return setIsSelectingEmoji(false);
            textarea.value = `${before}${emoji.name ? `<:${emoji.name}:${emoji.id}>` : emoji.emoji} ${after}`;
            textarea.focus();
            textarea.selectionStart = textarea.selectionEnd = before.length + (emoji.name ? emoji.name.length + emoji.id.length + 6 : emoji.emoji.length + 2);
            setIsSelectingEmoji(false);
        }
    };

    const filteredEmojis = React.useMemo(() => {
        if (!searchTerm) return allEmojis.data?.slice(0, 5);
        return allEmojis.data?.filter((emoji: any) =>
            emoji.name ? emoji.name.toLowerCase().includes(searchTerm.toLowerCase()) : emoji.aliases?.some((alias: any) => alias.toLowerCase().includes(searchTerm.toLowerCase()))
        );
    }, [searchTerm, allEmojis]);

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (isSelectingEmoji) {
                if (e.key === "ArrowDown") {
                    e.preventDefault();
                    setFocusedEmoji((prev: any) => Math.min(Math.max(prev + 1, 0), filteredEmojis!.length - 1));
                } else if (e.key === "ArrowUp") {
                    e.preventDefault();
                    setFocusedEmoji((prev: any) => Math.min(Math.max(prev - 1, 0), filteredEmojis!.length - 1));
                }
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [isSelectingEmoji, focusedEmoji, filteredEmojis]);

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (isSelectingEmoji && (e.key === "Enter" || e.key === "Tab")) {
                e.preventDefault();
                tagEmoji(filteredEmojis![focusedEmoji]);
                setIsSelectingEmoji(false);
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [isSelectingEmoji, focusedEmoji, filteredEmojis]);

    


    return {
        filteredEmojis,
        focusedEmoji,
        setFocusedEmoji,
        tagEmoji,
        isSelectingEmoji,
        setIsSelectingEmoji,
        allEmojis
    }

}